import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserService } from '../services/shared/user.service';
import { map, catchError } from 'rxjs/operators';
import { RoutingService } from '../services/routing.service';
import { AppSettingsService, SubdomainEnum } from '../services/app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizedLpGuard  {

  constructor(
    private userService: UserService,
    private appSettingsService: AppSettingsService,
    private routingService: RoutingService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const userIsLoggedIn = this.userService.isLoggedIn();
    // If the user is not logged in,
    // or trying to access a GP page from the LP website,
    // redirect to the login page by the subdomain
    if (!userIsLoggedIn) {
      // Attempt cross app login
      const isRegistered = next.queryParamMap.get('isRegistered') === 'True';
      return this.userService.crossAppLogin()
        .pipe(
          map((response: any) => {
            if (response) {
              return true;
            } else {
              if (isRegistered) {
                return this.routingService.getLoginUrlTree(false, true);
              } else {
                return this.routingService.getSignupUrlTree(false, true);
              }
            }
          }),
          catchError(err => {
            return of(this.routingService.getLoginUrlTree(false, true));
          })
        );
    } else {
      return true;
    }
  }
}
